import { Heading } from 'edrolo-ui';
import styles from './styles.scss';
import cx from 'classnames';
import pluralize from 'pluralize';

interface SelfMarkingProps {
  onChange: (rating: number) => void;
  mark: number;
  totalMarks: number;
}

export const SelfMarking = ({
  onChange,
  mark,
  totalMarks,
}: SelfMarkingProps) => {
  return (
    <div className={styles.selfMarking}>
      <div>
        <Heading level={6}>MARK YOUR RESPONSE</Heading>
      </div>
      <div>
        <div className={styles.ctaBlock}>
          <input
            className={cx(styles.input, styles.outline, styles.foreground)}
            onChange={(e) => onChange(Number(e.target.value))}
            value={mark}
            type="number"
            min={0}
            max={totalMarks}
            data-test="self-mark-input"
          />
          <p className={styles.totalMarks}>
            {' '}
            {`/ ${totalMarks} ${pluralize('MARK', totalMarks)}`}
          </p>
        </div>
      </div>
    </div>
  );
};
